import Cookies from "js-cookie";

const getRootDomain = (host: string) => host.split(".").slice(-2).join(".");

const isLocalHost = (host: string) =>
  host === "localhost" ||
  host === "::1" ||
  /^\d{1,3}(\.\d{1,3}){3}$/.test(host) ||
  !host.includes(".");

const getDomainOptions = () => {
  const host = location.hostname;

  if (isLocalHost(host)) return {};

  return { domain: getRootDomain(host) };
};

export const setCookie = (name: string, value: string, options = {}) => {
  Cookies.set(name, value, { ...getDomainOptions(), ...options });
};

export const getCookie = Cookies.get.bind(Cookies);

export const removeCookie = (name: string, options = {}) =>
  Cookies.remove(name, { ...getDomainOptions(), ...options });
